import { render } from "./DefaultTree.vue?vue&type=template&id=2eaf56fa"
import script from "./DefaultTree.vue?vue&type=script&lang=js"
export * from "./DefaultTree.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Vind\\Vind\\FomoFront\\VindFrontFomoApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QTree from 'quasar/src/components/tree/QTree.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QInput,QScrollArea,QTree});
